import Event from "../../event/event"
import {EventType} from "../../../gd/const/event"
import {ItemIconClass} from "../../../gd/const/item-icon/icon/item-icon-class";

export function getEventIconClass(event: Event) {
    let result = ''

    switch (event.type) {
        case EventType.PROJECT_EVENT                : result = "i5-event-project-event"; break
        case EventType.PROJECT_MILESTONE            : result = "i5-milestone"; break
        case EventType.PROJECT_DEADLINE             : result = "i5-event-project-deadline"; break
        case EventType.PROJECT_CREATED              : result = "i5-event-project-created"; break

        case EventType.COMPANY_EVENT                : result = "i5-organization"; break
        case EventType.COMPANY_HOLIDAY              : result = "i5-event-company-holiday"; break

        case EventType.PERSONAL_PAID_VACATION       : result = "i5-event-personal-vacation"; break
        case EventType.PERSONAL_NON_PAID_VACATION   : result = "i5-event-personal-vacation"; break
        case EventType.PERSONAL_SICK_LEAVE          : result = "i5-event-personal-sick-leave"; break
        case EventType.PERSONAL_TRAVEL              : result = "i5-event-personal-travel"; break

        case EventType.TASK_DEADLINE                :
            if (event.task) {
                const taskType = gd.session.taskTypes.get(event.task.taskTypeId)
                if (taskType) {
                    result = ItemIconClass[taskType.icon]
                }
            }
            break
    }

    return result
}